// Authentication utilities - KEYCLOAK/OIDC-BASED
// Uses access token from react-oidc-context for Bearer authentication

// Reference to the OIDC auth object (set by App.js on init)
let _authRef = null;

export const setAuthRef = (auth) => {
  _authRef = auth;
};

export const getAuthToken = () => {
  return _authRef?.user?.access_token || null;
};

export const setAuthToken = () => {
  // No-op: tokens are managed by OIDC client
};

export const removeAuthToken = () => {
  if (_authRef) {
    _authRef.signoutRedirect();
  }
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCurrentUser = () => {
  if (!_authRef?.user?.profile) return null;
  const p = _authRef.user.profile;
  return {
    username: p.preferred_username,
    email: p.email,
    first_name: p.given_name,
    last_name: p.family_name,
    full_name: [p.given_name, p.family_name].filter(Boolean).join(' ') || p.preferred_username,
  };
};

export const isAuthenticated = () => {
  return !!_authRef?.isAuthenticated;
};

// KEYCLOAK_MIGRATION: Legacy session-based code preserved below
// import sessionService from './sessionService';
// export const getAuthHeaders = () => {
//   const sessionId = sessionService.getSessionId();
//   return sessionId ? { 'X-Session-ID': sessionId } : {};
// };
